import { URL_PARAMETER_FRAME_KEY } from "../const/Constant.js";

const isIframe = () => window.self !== window.top;

const queryFrameKey = () => isIframe() ? (decodeURIComponent((new URL(document.location)).searchParams.get(URL_PARAMETER_FRAME_KEY)) || '') : '';


export {
    isIframe, queryFrameKey
}

